import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const primaryButton = css({
  width: 'fit-content',
  float: 'right',
  margin: theme.spacing(0, 2, 4, 0),
});
